module.exports = __webpack_public_path__ + "static/media/hexagon-back.480db84b.svg";